import ChipOptional from "../../../components/Chip/ChipOptional";

const SECTION_META_CHIP_SX = {
  height: "auto",
  maxWidth: "100%",
  alignSelf: "flex-start",
  borderRadius: "9px",
  pointerEvents: "none",
  "& .MuiChip-label": {
    display: "block",
    whiteSpace: "normal",
    fontSize: "9px",
    fontWeight: 800,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "text.secondary",
    padding: "6px 10px",
    lineHeight: 1.5,
  },
};

const SectionMetaChip = ({ label, sx = {} }) => {
  if (!label) return null;

  return (
    <ChipOptional
      label={label}
      size="small"
      sx={{ ...SECTION_META_CHIP_SX, ...sx }}
    />
  );
};

export default SectionMetaChip;
